import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { Feature } from "../../interfaces/feature";
import { Epic } from "../../interfaces/epic";
import { MzBaseModal } from "ng2-materialize";
import { Project } from "../../interfaces/project";
import { Utils } from "../../utils/utils";
import { Subject } from "rxjs";
import { MzToastService } from "ng2-materialize";

@Component({
  selector: "app-edit-theme-dialog",
  templateUrl: "./edit-theme-dialog.component.html",
  styleUrls: ["./edit-theme-dialog.component.scss"],
})
export class EditThemeDialogComponent extends MzBaseModal implements OnInit {
  readonly env: any = environment;
  readonly presetThemeColors = Utils.presetThemeColors;
  private resultSubject: Subject<Epic>;

  @Input() project: Project;
  @Input() epics: Epic[];

  @Output() createThemeClicked: EventEmitter<any> = new EventEmitter<any>();

  newTheme: Epic;
  canCreate: boolean;
  error: string;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private toastService: MzToastService
  ) {
    super();
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.resultSubject = new Subject<Epic>();
    this.newTheme = { color: this.presetThemeColors[0][0] } as Epic;
    this.modalComponent.onClose.subscribe((x) => {
      if (!this.resultSubject.closed) {
        this.resultSubject.next(null);
        this.resultSubject.complete();
      }
    });
  }

  async validate(newValue) {
    let nameNotEmpty = newValue && newValue.trim() !== "";
    let nameAlreadyExists =
      this.epics &&
      this.epics.filter(
        (x) =>
          x.name.localeCompare(newValue, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
            usage: "search",
          }) === 0
      ).length > 0;
    this.canCreate = nameNotEmpty && !nameAlreadyExists;
    this.error = nameAlreadyExists
      ? "Ein Epic mit dieser Bezeichnung existiert bereits."
      : null;
  }

  /**
   * Event handler for Create button.
   */
  async createTheme(flag: boolean) {
    console.log("Save Button pressed");
    console.log(this.project);
    console.log(this.epics);
    if (this.canCreate) {
      this.newTheme.projectId = this.project._id;
      let themeCreatedSubject = new Subject<Epic>();
      this.createThemeClicked.emit({
        newTheme: this.newTheme,
        cbSubject: themeCreatedSubject,
      });
      let themeCreated = await themeCreatedSubject.first().toPromise();
      if (!this.resultSubject.closed) {
        this.resultSubject.next(themeCreated);
        this.resultSubject.complete();
      }
      if (flag) {
        this.toastService.show("Epic erstellt!", 4000, "confirm-toast");
      } else {
        this.toastService.show("Epic gespeichert!", 4000, "confirm-toast");
      }
      this.newTheme = { color: this.presetThemeColors[0][0] } as Epic;
      this.canCreate = false;
      this.closeThemeModal();
    }
  }

  /**
   * closes ThemeModal and resets newTheme object
   */
  closeThemeModal() {
    this.newTheme = { color: this.presetThemeColors[0][0] } as Epic;
    this.canCreate = false;
    this.error = "";
    this.modalComponent.close();
  }

  async getResultAsync() {
    this.modalComponent.open();
    this.resultSubject = new Subject<Epic>();
    return this.resultSubject.first().toPromise();
  }

  async getEditResultAsync(theme) {
    this.newTheme = JSON.parse(JSON.stringify(theme));
    this.changeDetectorRef.detectChanges();
    this.modalComponent.open();
    setTimeout(Materialize.updateTextFields, 10);
    this.resultSubject = new Subject<Epic>();
    return this.resultSubject.first().toPromise();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/edit-theme-dialog/edit-theme-dialog.component.ts